export enum BlackjackAssetType {
  StartButton = 'start_button',
  PlayIcon = 'play_icon',
  Chip10 = 'chip_10',
  Chip50 = 'chip_50',
  Chip100 = 'chip_100',
  Chip500 = 'chip_500',
  Chip1k = 'chip_1k',
  Chip5k = 'chip_5k',
  Chip10k = 'chip_10k',
  Chip50k = 'chip_50k',
  Chip100k = 'chip_100k',
  ChipSmall10 = 'chip_small_10',
  ChipSmall50 = 'chip_small_50',
  ChipSmall100 = 'chip_small_100',
  ChipSmall500 = 'chip_small_500',
  ChipSmall1k = 'chip_small_1k',
  ChipSmall5k = 'chip_small_5k',
  ChipSmall10k = 'chip_small_10k',
  ChipSmall50k = 'chip_small_50k',
  ChipSmall100k = 'chip_small_100k',
  CardBack = 'card_back',
  CardShadow = 'card_shadow',
  CardClub = 'card_club',
  CardDiamond = 'card_diamond',
  CardHeart = 'card_heart',
  CardSpade = 'card_spade',
}

export enum BlackjackSpriteType {
  NumbersLargePink = 'numbers_large_pink',
  NumbersLargeBlack = 'numbers_large_black',
  NumbersSmallPink = 'numbers_small_pink',
  NumbersSmallBlack = 'numbers_small_black',
}

export enum BlackjackTranslationsType {
  Play = 'play', // Play
  Bet = 'bet', // Bet
  Balance = 'balance', // Balance
  PlaceYourBet = 'place-your-bet', // Place your bet
  Push = 'push', // Push
  DealerWins = 'dealer-wins', // Dealer Wins
  Won = 'won', // Won
  Bust = 'bust', // Bust
  Blackjack = 'blackjack', // Blackjack
  Lost = 'lost', // Lost
  DealerRules = 'dealer-rules', // Dealer must stand on soft 17
  BlackjackRules = 'blackjack-rules', // Blackjack pays 3 to 2
  Streak = 'streak', // Streak
  Bonus = 'bonus', // Bonus
  Round = 'round', // Round
}

export enum BlackjackStylesType {
  BackgroundPrimary = '--background-primary',
  ButtonPrimaryLabel = '--game-label-color',
  CardBackground = '--card-background',
}
